module.exports = __webpack_public_path__ + "static/assets/f6c43bf1ce1c14ee9e868977dc720f8e.png";